export type SidebarSection = { id: string; title: string; tagIds: string[] };
export type AppBenefitSection = { id: string; appId: string };
export type PageSection = TagsSection | TagSection | TreeSection;

export type TagsSection = {
  id: string;
  type: DynamicSectionType.TAGS;
  tagIds: string[];
  skin: TagListSectionSkin;
};

export type TagSection = {
  id: string;
  type: DynamicSectionType.TAG;
  tagId: string;
  sortMethods: TagSectionSortMethod[];
  skin: TagSectionSkin;
};

export type TreeSection = {
  id: string;
  type: DynamicSectionType.TAG_TREE;
  rootTagId: string;
  subCategories: { subCategoryTagId: string; appIds: string[] }[];
  keywords: string[];
};

export enum DynamicSectionType {
  TAG = 'TAG',
  TAGS = 'TAGS',
  TAG_TREE = 'TAG_TREE',
}

export enum TagSectionSortMethod {
  NO_SORT = 'NO_SORT',
  INSTALLS = 'INSTALLS',
  GEO = 'GEO',
  REVIEWS_RATING = 'REVIEWS_RATING',
  APP_MARKET_SCORE = 'APP_MARKET_SCORE',
  ML_MODEL_RANKING = 'ML_MODEL_RANKING',
  MANUAL = 'MANUAL',
  DEALER = 'DEALER',
}

export enum TagSectionSkin {
  COLLECTION = 'COLLECTION',
  PROMO = 'PROMO',
}

export enum TagListSectionSkin {
  UNKNOWN = 'UNKNOWN',
  PACKAGE = 'PACKAGE',
}
